import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useLang } from "../contexts/LanguageContext";
import { BreederCard } from "../components/BreederCard";

const BreedersList = () => {
  const { t } = useLang();
  const [breeders, setBreeders] = useState([]);
  useEffect(() => { api.get("/breeders").then((r) => setBreeders(r.data)); }, []);
  return (
    <div data-testid="breeders-list-page" className="bg-[var(--monzal-bg)] min-h-screen">
      <div className="border-b border-white/5">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-20">
          <div className="overline">{t("nav.breeders").toUpperCase()}</div>
          <h1 className="font-display font-light text-4xl lg:text-6xl text-white tracking-tight mt-4">
            {t("home.breedersTitle")}
          </h1>
          <p className="text-gray-400 mt-4 max-w-xl">{t("home.breedersSub")}</p>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {breeders.map((b) => <BreederCard key={b.id} breeder={b} />)}
      </div>
    </div>
  );
};

export default BreedersList;
